module.exports = __webpack_public_path__ + "img/dl (14).95f8177d.jpg";